import { apiBaseUrl } from 'app/src/msw/companyagreement/api/apiBaseUrl'
import { getAllStaticCategoriesCollection } from 'app/src/msw/companyagreement/initialSeed/categories'
import type { companyagreementApi } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

export const getCategory = http.get<{ categoryId: string }, companyagreementApi.ProposalCreateVariables, object>(
  apiBaseUrl + '/categories/:categoryId',
  async ({ params }) => {
    const { categoryId } = params

    console.log('MSW: getCategory called with categoryId', categoryId)
    const allCategories = await getAllStaticCategoriesCollection()

    const category = allCategories.find((cat) => cat.categoryId === categoryId)
    console.log('MSW: getCategory', categoryId, category)

    return HttpResponse.json(category || {})
  },
)
